import { render, staticRenderFns } from "./SegmentListCreateOrEdit.vue?vue&type=template&id=8259109a&"
import script from "./SegmentListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports